module.exports = __webpack_public_path__ + "236f0efc7848fb7a5e5bf24f41fc84c5.png";